import { render, staticRenderFns } from "./CartRecap.vue?vue&type=template&id=082b35d7"
import script from "./CartRecap.vue?vue&type=script&lang=js"
export * from "./CartRecap.vue?vue&type=script&lang=js"
import style0 from "./CartRecap.vue?vue&type=style&index=0&id=082b35d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports